import React from "react";
import { Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import rootStyles from "../styles.module.scss";
import { isValidPassword } from "shared/utils/Validate";
import { NotistackServices, UserServices } from "shared/services";

export const ChangePassword = () => {
	const [loading, setLoading] = React.useState(false);
	const [showPassword, setShowPassword] = React.useState([false, false]);
	const [currentPassword, setCurrentPassword] = React.useState("");
	const [newPassword, setNewPassword] = React.useState("");
	const [confirmPassword, setConfirmPassword] = React.useState("");

	const handleClickShowPassword = (index: number) => () =>
		setShowPassword((show) => {
			const newShow = [...show];
			newShow[index] = !newShow[index];
			return newShow;
		});

	const handleChangePassword = async () => {
		setShowPassword([false, false]);
		setLoading(true);

		try {
			await UserServices.changePassword(currentPassword, newPassword);
			setCurrentPassword("");
			setNewPassword("");
			setConfirmPassword("");
		} catch (error) {
			console.error("Error changing password:", error);
			NotistackServices.showErrorMessage("Ocorreu um erro ao alterar a senha. Verifique sua senha atual e tente novamente.");
		}

		setLoading(false);
	};

	const formValid =
		isValidPassword(currentPassword) && isValidPassword(newPassword) && currentPassword !== newPassword && newPassword === confirmPassword;

	const isDisabled = !formValid || !isValidPassword(currentPassword) || !isValidPassword(newPassword) || newPassword !== confirmPassword || loading;

	return (
		<div className={rootStyles.card}>
			<h4>Alterar Senha</h4>
			<div className={rootStyles.formGrid}>
				<div className={rootStyles.row}>
					<TextField
						fullWidth
						label="Senha Atual"
						type={showPassword[0] ? "text" : "password"}
						variant="outlined"
						size="small"
						autoComplete="password"
						value={currentPassword}
						onChange={(e) => setCurrentPassword(e.target.value)}
						disabled={loading}
						error={currentPassword !== "" && !isValidPassword(currentPassword)}
						helperText={
							currentPassword !== "" && !isValidPassword(currentPassword)
								? "A senha deve conter pelo menos 8 caracteres e não conter espaços."
								: ""
						}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={handleClickShowPassword(0)}
										edge="end"
										disabled={loading}
									>
										{showPassword[0] ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<div /> {/* Spacer or empty col if needed, simple mapping to mockup */}
				</div>
				<div className={rootStyles.row}>
					<TextField
						fullWidth
						label="Nova Senha"
						type={showPassword[1] ? "text" : "password"}
						variant="outlined"
						size="small"
						autoComplete="new-password"
						value={newPassword}
						onChange={(e) => setNewPassword(e.target.value)}
						disabled={loading}
						error={newPassword !== "" && (!isValidPassword(newPassword) || newPassword === currentPassword)}
						helperText={
							newPassword !== "" && !isValidPassword(newPassword)
								? "A senha deve conter pelo menos 8 caracteres e não conter espaços."
								: newPassword !== "" && newPassword === currentPassword
									? "A nova senha deve ser diferente da senha atual."
									: ""
						}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={handleClickShowPassword(1)}
										edge="end"
										disabled={loading}
									>
										{showPassword[1] ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<TextField
						fullWidth
						label="Confirmar Senha"
						type={showPassword[1] ? "text" : "password"}
						variant="outlined"
						size="small"
						value={confirmPassword}
						onChange={(e) => setConfirmPassword(e.target.value)}
						disabled={loading}
						error={newPassword !== "" && confirmPassword !== newPassword}
						helperText={newPassword !== "" && confirmPassword !== newPassword ? "As senhas não coincidem." : ""}
						autoComplete="new-password"
					/>
				</div>
			</div>
			<div className={rootStyles.actions}>
				<Button
					variant="contained"
					color="primary"
					disabled={isDisabled}
					loading={loading}
					onClick={handleChangePassword}
				>
					Atualizar Senha
				</Button>
			</div>
		</div>
	);
};
